import { render, staticRenderFns } from "./FloatingNotification.vue?vue&type=template&id=6a13fe1e&scoped=true"
import script from "./FloatingNotification.vue?vue&type=script&lang=js"
export * from "./FloatingNotification.vue?vue&type=script&lang=js"
import style0 from "./FloatingNotification.vue?vue&type=style&index=0&id=6a13fe1e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../Desktop/Trabajo/gotrading/front/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a13fe1e",
  null
  
)

export default component.exports